(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("kontentDelivery", [], factory);
	else if(typeof exports === 'object')
		exports["kontentDelivery"] = factory();
	else
		root["kontentDelivery"] = factory();
})(self, () => {
return 